import { loadCategorySlaPreview } from '@/utils/sla-due-preview'

/**
 * Shared ticket category → priority + business-hours due preview.
 * Expects `this.ticket`, sets `this.resolveDate` / `this.dueDate`.
 * Uses `this.profile?.userGroupId` when present, else Vuex User/user.
 *
 * Set `slaPreviewWithLoading: false` on the component to skip the activity spinner
 * (e.g. TicketTabDetail — category fetch already drives loading via HTTP interceptor).
 */
export default {
  methods: {
    /**
     * @param {number|string} categoryId
     * @param {{ withLoading?: boolean }} [opts]
     */
    async getResolveAndDue (categoryId, opts = {}) {
      const withLoading = opts.withLoading ?? (this.slaPreviewWithLoading !== false)
      try {
        if (withLoading) {
          this.$store.dispatch('activity/increaseLoading')
        }
        const groupId = this.profile?.userGroupId
          ?? this.$store.getters['User/user']?.userGroupId
        const preview = await loadCategorySlaPreview({
          categoryId,
          groupId,
          ticketId: this.ticket?.id
        })
        if (this.ticket) {
          this.ticket.priority = preview.priority
        }
        this.resolveDate = preview.dueDateDisplay
        this.dueDate = preview.dueDateDisplay
      } catch (error) {
        console.error(error)
        this.resolveDate = ''
        this.dueDate = ''
      } finally {
        if (withLoading) {
          this.$store.dispatch('activity/decreaseLoading')
        }
      }
    }
  }
}
